module.exports = __webpack_public_path__ + "static/media/join-img.54764ed8.png";